import React from 'react';
import { getRolesSelector, getUserSelector } from '../appContainer/selectors';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

const stateSelector = createStructuredSelector({
  userRolesHOC: getRolesSelector,
  userObjHOC: getUserSelector,
});

const DisableForRoles = WrappedComponent => {
  if (!WrappedComponent) {
    return null;
  }
  class WrappedComponentClass extends React.Component {
    render() {
      const { userObjHOC, userRolesHOC, disabledForRoles, ...rest } = this.props;
      const userLoaded = !!Object.keys(userObjHOC).length && !!Object.keys(userRolesHOC).length;
      const userRole = userRolesHOC[userObjHOC.role];
      const isDisabled =
        userLoaded && disabledForRoles && disabledForRoles.length ? disabledForRoles.includes(userRole) : false;

      return <WrappedComponent {...rest} roleBasedDisable={isDisabled} />;
    }
  }

  return connect(stateSelector)(WrappedComponentClass);
};

export default DisableForRoles;
